import { SnackBarComponent } from './snack-bar/snack-bar.component';

export const COMPONENTS = [SnackBarComponent];

export { SnackBarComponent } from './snack-bar/snack-bar.component';
